var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('b-nav',[_c('b-nav-item',{attrs:{"active":""}},[_vm._v("fancy quiz app")]),_c('b-nav-item',[_vm._v("counter: "+_vm._s(_vm.numCorrect)+"/"+_vm._s(_vm.numTotal))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }